import { AnimatePresence } from "tamagui";
import { Paragraph } from "./Typography";
type FieldErrorProps = {
  /**
   * error will be hidden if undefined
   */
  message?: string;
};
export const FieldError = ({
  message
}: FieldErrorProps) => {
  return <AnimatePresence data-sentry-element="AnimatePresence" data-sentry-component="FieldError" data-sentry-source-file="FieldError.tsx">
      {message ? <Paragraph key="error" transition="200ms" mt="$2" theme="alt2" enterStyle={{
      y: -4,
      scaleY: 0.2,
      opacity: 0
    }} exitStyle={{
      y: -4,
      opacity: 0,
      scaleY: 0
    }} opacity={1} y={0} scaleY={1} bold>
          {message}
        </Paragraph> : null}
    </AnimatePresence>;
};